<template>
  <div class="w100 Contenido">
    <Titulo :seccion="Herramientas.Veris.title" icon="images"/>
    <Descripcion>
      {{ Herramientas.Veris.description }}
    </Descripcion>
    <Tabla nombre="Veris" :columnas="columnasTabla" :id-herramienta="0"/>
  </div>
</template>

<script>
import { ColumnasTabla, Herramientas } from "../../Auxiliares/Enums";

export default {
  name: "Veris",
  data() {
    return {
      columnasTabla: [ ColumnasTabla.Productor, ColumnasTabla.Establecimiento, ColumnasTabla.Localidad ],
      Herramientas
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../Css/Componentes.scss";
@import "../../Css/Globales.css";
@import "../../Css/Secciones/Tabla.css";
</style>
